export default __webpack_public_path__ + "assets/pakistan-flag.png";